import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	incidentManagementSectionHeading: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.incident-management-section-heading',
		defaultMessage: 'Incident management fields',
		description:
			'Heading of the settings section which provides information about the new incident management fields that can be added to incidents',
	},
	newIncidentManagementExpandButtonLabel: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.new-incident-management-expand-button-label',
		defaultMessage: 'New incident management settings section expander',
		description:
			'Label for the collapsible button aligned with the header in the new incident management section.',
	},
});
